import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import React from 'react'
import Grid from '@mui/material/Grid2'
import { useTranslation } from 'react-i18next'

/**
 * Loading indicator component.
 *
 * @param message - Optional message type to display: 'parsing' or 'saving'. Defaults to 'loading'.
 * @returns Loading indicator component.
 * @notExported
 */
interface ILoadingIndicatorProps {
  message?: 'parsing' | 'saving' | 'loading'
}

const LoadingIndicator: React.FC<ILoadingIndicatorProps> = ({ message = 'loading' }) => {
  const { t } = useTranslation()
  const dialogTitleId = 'loading-indicator-title'

  const getMessageKey = (): string => {
    switch (message) {
      case 'parsing':
        return 'admin.parse.loading.parsing'
      case 'saving':
        return 'admin.parse.loading.saving'
      default:
        return 'loading'
    }
  }

  return (
    <Dialog sx={{ zIndex: 9999 }} open aria-labelledby={dialogTitleId}>
      <Card>
        <CardHeader title={t(getMessageKey())} slotProps={{ title: { id: dialogTitleId } }} />
        <Grid container justifyContent="center" sx={{ p: 2 }}>
          <CircularProgress aria-label={t(getMessageKey())} />
        </Grid>
      </Card>
    </Dialog>
  )
}

export default LoadingIndicator
